import React, { useEffect, useState } from "react";
import unassignedActivitiesStyle from "./unassignedActivitiesStyles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import IconButton from "@mui/material/IconButton";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import ApiClient from "../../../services/ApiClient";
import { Table, TableBody, TableContainer } from "@mui/material";
import ActivityTableRow from "../ActivityTable/ActivityTableRow";
import { Activity } from "../../../types/Activity";
import { BackofficeUser } from "../../../types/BackofficeUser";

type UnassignedActivitiesProps = {
  updateFilteredActivities: Function;
};

const UnassignedActivities = ({ updateFilteredActivities }: UnassignedActivitiesProps) => {
  const [expanded, setExpanded] = useState(false);
  const [unassignedActivities, setUnassignedActivities] = useState<Activity<BackofficeUser>[]>([]);

  const updateAllActivities = () => {
    fetchUnassignedActivities();
    updateFilteredActivities();
  };

  const fetchUnassignedActivities = () => {
    ApiClient.get("activities?exists[assignedUser]=false&pagination=false&deleted=false&done=false").then(
      (activitiesResponse) => {
        setUnassignedActivities(activitiesResponse["hydra:member"]);
      }
    );
  };

  useEffect(() => {
    fetchUnassignedActivities();
    let checkUnassignedActivitiesTimer = setTimeout(fetchUnassignedActivities, 30000);
    return () => {
      clearTimeout(checkUnassignedActivitiesTimer);
    };
  }, []);

  if (unassignedActivities.length === 0) {
    return null;
  }

  return (
    <Paper sx={unassignedActivitiesStyle.paper}>
      <Grid container sx={{
        alignItems: "center"
      }}>
        <Grid size={1} />
        <Grid sx={unassignedActivitiesStyle.headline} size={10}>
          {unassignedActivities.length} Aktivitäten nicht zugeordnet
        </Grid>
        <Grid size={1}>
          <IconButton onClick={() => setExpanded(!expanded)} size="large">
            {!expanded ? <ExpandMore /> : <ExpandLess />}
          </IconButton>
        </Grid>
        {expanded && (
          <TableContainer>
            <Table>
              <TableBody>
                {_.map(unassignedActivities, (activity) => (
                  <ActivityTableRow
                    key={activity.id}
                    activity={activity}
                    update={updateAllActivities}
                    isExternalView={false}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Grid>
    </Paper>
  );
};

export default UnassignedActivities;
